export default "__VITE_ASSET__CcUXKbx7__"